var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3585_2452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1133 8.75293C12.0266 9.37293 12.6666 10.2129 12.6666 11.3329V13.3329H15.3333V11.3329C15.3333 9.8796 12.9533 9.0196 11.1133 8.75293Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 7.99984C11.4733 7.99984 12.6666 6.8065 12.6666 5.33317C12.6666 3.85984 11.4733 2.6665 9.99995 2.6665C9.68661 2.6665 9.39328 2.73317 9.11328 2.8265C9.66661 3.51317 9.99995 4.3865 9.99995 5.33317C9.99995 6.27984 9.66661 7.15317 9.11328 7.83984C9.39328 7.93317 9.68661 7.99984 9.99995 7.99984Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 7.99984C7.47398 7.99984 8.66732 6.8065 8.66732 5.33317C8.66732 3.85984 7.47398 2.6665 6.00065 2.6665C4.52732 2.6665 3.33398 3.85984 3.33398 5.33317C3.33398 6.8065 4.52732 7.99984 6.00065 7.99984ZM6.00065 3.99984C6.73398 3.99984 7.33398 4.59984 7.33398 5.33317C7.33398 6.0665 6.73398 6.6665 6.00065 6.6665C5.26732 6.6665 4.66732 6.0665 4.66732 5.33317C4.66732 4.59984 5.26732 3.99984 6.00065 3.99984Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 8.6665C4.22033 8.6665 0.666992 9.55984 0.666992 11.3332V13.3332H11.3337V11.3332C11.3337 9.55984 7.78033 8.6665 6.00033 8.6665ZM10.0003 11.9998H2.00033V11.3398C2.13366 10.8598 4.20033 9.99984 6.00033 9.99984C7.80033 9.99984 9.86699 10.8598 10.0003 11.3332V11.9998Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3585_2452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.416e2239a1fa1c630ebefbd1b9f1374c.svg";
export { ForwardRef as ReactComponent };